<div class="w-100 h-100 d-flex justify-content-center align-items-center">    
    <nz-result nzStatus="404" nzTitle="404" nzSubTitle="Sorry, the page you visited does not exist.">
        <div nz-result-extra>
            <button nz-button nzType="primary" (click)="backToHome()">Back Home</button>
        </div>
    </nz-result>
</div>
